import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalBaseComponent, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { SystemParameterModel, CoreService, SystemParameterType } from 'src/app/services/api-services';

@Component({
    selector: 'app-system-parameter-edit',
    templateUrl: './system-parameter-edit.component.html',
    styleUrls: ['./system-parameter-edit.component.scss'],
})
export class SystemParameterEditComponent extends ModalBaseComponent {
    constructor(
        private translatedToastrService: TranslatedToastrService,
        private bsModalRef: BsModalRef,
        private coreService: CoreService,
        protected override validationHandlerService: ValidationHandlerService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

    //input properties
    public title: string;
    public item: SystemParameterModel;
    public isCheckbox: boolean = false;

    private getFormGroup(): FormGroup {
        return new FormGroup({
            id: new FormControl({ value: '', disabled: true }),
            value: new FormControl(this.isCheckbox ? false : '', [Validators.required]),
            description: new FormControl(''),
        });
    }

    public form: FormGroup = this.getFormGroup();

    public init() {
        this.form = this.getFormGroup();
        this.form.patchValue({
            ...this.item,
            value: this.isCheckbox ? this.item.value === 'true' : this.item.value,
        });
    }

    ngOnInit() {
        this.init();
    }

    public onSave = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            let itemToSave: SystemParameterModel = {
                id: this.item.id,
                value: '',
                description: this.item.description,
            };

            itemToSave = <SystemParameterModel>this.form.getRawValue();

            if (this.isCheckbox) {
                let formValue = this.form.value;
                itemToSave.value = formValue.value ? 'true' : 'false';
            }

            return this.handleSpinner(
                firstValueFrom(this.coreService.updateSystemParameter(itemToSave))
                    .then(res => {
                        this.onClose(this.bsModalRef, 'save_success');
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err, this.form);
                    })
            );
        }
    };

    public onFormGroupEvent(event: FormGroup) {
        const addressForm: FormGroup = event;
        if (addressForm) {
            this.form.addControl('address', addressForm);
        }
    }
}
